var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86322 7.69851L8.54169 8.01814C8.54169 8.01814 7.7775 8.77802 5.69161 6.70392C3.60574 4.6299 4.36992 3.87006 4.36992 3.87006L4.57236 3.66875C5.07114 3.17283 5.11815 2.37665 4.68298 1.7954L3.7929 0.606409C3.25432 -0.113 2.21362 -0.208034 1.59632 0.405761L0.488365 1.50743C0.182279 1.81178 -0.0228366 2.2063 0.00203873 2.64397C0.0656742 3.76365 0.572266 6.17274 3.39909 8.9835C6.39679 11.9642 9.20953 12.0826 10.3598 11.9754C10.7236 11.9415 11.04 11.7562 11.2949 11.5027L12.2977 10.5057C12.9746 9.83261 12.7837 8.67877 11.9177 8.20802L10.5691 7.47489C10.0004 7.16578 9.30765 7.25656 8.86322 7.69851Z",
    fill: "#F4BD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNoIcon);
export default __webpack_public_path__ + "static/media/contact_no_icon.3e7fa7390a986939dfd07b0e43eb9d33.svg";
export { ForwardRef as ReactComponent };